// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import SectionHeader from 'components/text/SectionHeader';
// APOLLO
import getQuestionsQuery from 'ApolloClient/Queries/getQuestions';
import { compose, graphql } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';

class AdminQuestions extends React.PureComponent {
  render() {
    return (
      <PageContainer flex="center">
        <SectionHeader>Admin Questions</SectionHeader>
      </PageContainer>
    );
  }
}

export default compose(
  // graphql(DELETE_QUESTION, { name: 'deleteQuestion' }),
  // graphql(CREATE_QUESTION, { name: 'createQuestion' }),
  graphql(getQuestionsQuery, { name: 'getQuestionsQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'getQuestionsQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'getQuestionsQuery' }),
)(AdminQuestions);



// WEBPACK FOOTER //
// ./src/routes/admin-questions/index.js